import { Suspense } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { ErrorBoundary } from '@/components/errorBoundary/ErrorBoundary';

interface SuspenseErrorBoundaryProps {
  children: React.ReactNode;
  errorBoundaryFallback?: React.ComponentType<FallbackProps>;
  suspenseFallback?: React.ReactNode;
  onError?: (error: Error, handled: boolean) => void;
}

export function SuspenseErrorBoundary({
  children,
  errorBoundaryFallback,
  suspenseFallback,
  onError,
}: SuspenseErrorBoundaryProps) {
  return (
    <ErrorBoundary fallback={errorBoundaryFallback} onError={onError}>
      <Suspense fallback={suspenseFallback}>{children}</Suspense>
    </ErrorBoundary>
  );
}
